import { render, staticRenderFns } from "./wccd.vue?vue&type=template&id=08c1f73b&"
import script from "./wccd.vue?vue&type=script&lang=js&"
export * from "./wccd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports